/**
 * Return pixel value with `px` unit
 */
export function px2px(px) {
    return "".concat(px, "px");
}
